export default __webpack_public_path__ + "static/media/mind.4705def7.png";